import {FC} from 'react'
import ReactLoading from 'react-loading'

import './Loading.css'

type Props = {
  height?: number
  width?: number
}

const Loading: FC<Props> = ({height = 50, width = 50}) => {
  return (
    <div className='loading-all' id='loading-all'>
      <ReactLoading type='spin' color='#D5D5D5' height={height} width={width} />
      {/* <p className='loading-text'>Aguarde, alguns instantes...</p> */}
    </div>
  )
}

export {Loading}
